// extracted by mini-css-extract-plugin
export default {"exampleModuleContainer":"Client-src-prime-examplemodule-components-ExampleModuleLayout__exampleModuleContainer--IWDx0"};